//import { useSelector, useDispatch } from 'react-redux';
const DEFAULT_COVER_REVUE = '/uploads/revue.jpg';
async function getBooks(API_BASE, token, code_etablissement) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const workRes = await fetch(`${API_BASE}/works?code_etablissement=${code_etablissement}`, {
        method: "GET",
        headers,
    });

    if (!workRes.ok) {
        throw new Error("Erreur lectures des Works: " + (await workRes.text()));
    }
    var work = await workRes.json();
    //console.log("Work:", work);
    var obj = [];
    work.map((item) => {
        try {
            item.author = item.contributions.find((contributor) => contributor.role === "Auteur").agent.name;
            if (item.author === "") {
                item.author = "Inconnu";
            }
            item.category = item.genre || "";
            item.work_id = item.ID || "";
            //item.publisher = item.expressions[0].manifestations[0].publisher || "";
            var baffiche = false;
            if (item.expressions[0].manifestations.length > 1) {
                console.log(item.expressions[0].manifestations.length + " manifestations pour le livre:", item);
                baffiche = true;
            }

            item.expressions[0].manifestations.map((manifestation, index) => {
                var item2 = { ...item }
                item2.publisher = manifestation.publisher || "";
                item2.year = manifestation.pub_date || "";
                item2.isbn = manifestation.isbn || "";
                item2.manifestation_id = manifestation.ID || "";
                item2.summary = manifestation.summary || "";
                item2.cover = manifestation.cover_url || "";
                item2.tag = manifestation.tag || "";
                item2.type = manifestation.type || "books";
                if (item2.type == 'review' && item2.cover === '') item2.cover = DEFAULT_COVER_REVUE;
                item2.borrower = manifestation.borrower || "";
                item2.description = manifestation.description || "";
                item2.rating = manifestation.preview_link || "";

                try {
                    if (manifestation.items != undefined) {
                        if (manifestation.items.length > 1) {
                            if (item.expressions[0].manifestations.length == 1) console.log(item.expressions[0].manifestations.length + " manifestations pour le livre:", item);
                            baffiche = true;
                        }
                        manifestation.items.map((theitem) => {
                            var item3 = { ...item2 }
                            item3.qrcode_data = theitem.qrcode_data || "";

                            item3.emplacement = theitem.location || "";
                            item3.condition = theitem.condition || "Bon";
                            item3.item_id = theitem.ID.toString() || "";
                            item3.ID = theitem.ID.toString() || "";
                            item3.status = theitem.status;
                            item3.CreatedAt = theitem.CreatedAt || "";
                            if (baffiche) {
                                console.log("Item ->", theitem.ID);
                                item3.baffiche = true;
                            }
                            obj.push(item3);
                        })
                    }
                } catch (e) {
                    console.log(e);
                }
            })
            /*item.year = item.expressions[0].manifestations[0].pub_date || "";
            item.summary = item.expressions[0].manifestations[0].summary || "";
            item.cover = item.expressions[0].manifestations[0].cover_url || "";
            item.borrower = item.expressions[0].manifestations[0].borrower || "";
            item.status = item.expressions[0].manifestations[0].status || "";
            item.manifestation_id = item.expressions[0].manifestations[0].ID || "";
            item.rating = item.expressions[0].manifestations[0].preview_link || "";
            item.isbn = item.expressions[0].manifestations[0].isbn || "";
            item.description = item.expressions[0].manifestations[0].description || "";*/


            // if (item.expressions[0].manifestations[0].items.length > 1) { console.log(item.expressions[0].manifestations[0].items.length + " items pour le livre:", item); }
            /* item.expressions[0].manifestations[0].items.map((theitem) => {
                 var item2 = { ...item }
                 item2.qrcode_data = theitem.qrcode_data || "";
                 item2.rating = item.rating || "";
                 item2.emplacement = theitem.location || "";
                 item2.condition = theitem.condition || "Bon";
                 item2.item_id = theitem.ID.toString() || "";
                 item2.ID = theitem.ID.toString() || "";
                 item2.status = theitem.status;
                 item2.CreatedAt = theitem.CreatedAt || "";
                 obj.push(item2);
             })*/
        } catch (e) {
            console.log(e);
        }

    })
    //obj = obj.sort((a, b) => a.title.localeCompare(b.title));
    obj = obj.sort((a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt));
    //console.log("Obj:", obj);


    // On renvoie tout l'ensemble
    return {
        work: obj,
    };
}
export default getBooks;